export default {
  loading: true,
  listWareHouses: [],
  fieldWareHouses: [
    { key: 'valor', label: 'Código' },
    { key: 'descripcion', label: 'Nombre' },
    { key: 'actions', label: '' },
  ],
  pagination: {
    items: 0,
    pages: 0
  },
};
